const STRING_BOOLEANS = {
	true: true,
	True: true,
	false: false,
	False: false
};
export const stringToBoolean = (bool: string) => STRING_BOOLEANS[bool];
